<template>
  <div class="business">
    <div>

      <div class="row margin-t-s">
        <div class="datatable-outer-container">
          <data-table :columns="exemptTableColumns" :tableData="chapterData" :showinrow="true" :withForm="false"
            :showhistory="false" :showdelete="false" :showedit="false">
            <template v-slot:rowcontent="slotprops">
              <div>
                <p v-if="slotprops.value.column.key == 'slno'">{{ slotprops.value.index + 1 }}</p>
                <p v-if="slotprops.value.column.key == 'particulars'">
                {{
                  slotprops.value.record.InvestmentComponentType ?
                    slotprops.value.record.InvestmentComponentType.abbreviation : slotprops.value.record.display_group
                }} - {{
                  slotprops.value.record.InvestmentComponentType ?
                    slotprops.value.record.InvestmentComponentType.name : slotprops.value.record.name
                }}</p>
                <p v-if="slotprops.value.column.key == 'limits' 
      && slotprops.value.record.InvestmentComponentType.name !== 'NPS Employer Contribution' 
      && slotprops.value.record.InvestmentComponentType.name !== 'Political  Party Donation'
      && slotprops.value.record.InvestmentComponentType.name !== 'Interest on Education Loan'">{{
                 Number( slotprops.value.record.InvestmentComponentType ?
                    slotprops.value.record.InvestmentComponentType.maximumAmount :
                    (Object.keys(slotprops.value.record.rule).length ? slotprops.value.record.rule.maximum_limit : null)).toLocaleString("en-in")
                }}
                </p>
                <p v-if="slotprops.value.column.key == 'limits' && (slotprops.value.record.InvestmentComponentType.name == 'NPS Employer Contribution' || slotprops.value.record.InvestmentComponentType.name == 'Interest on Education Loan' || slotprops.value.record.InvestmentComponentType.name == 'Political  Party Donation')" >{{
                 ( slotprops.value.record.InvestmentComponentType ?
                    slotprops.value.record.InvestmentComponentType.maximumAmount :
                    (Object.keys(slotprops.value.record.rule).length ? slotprops.value.record.rule.maximum_limit : null))
                }}
                </p>
                <p v-if="slotprops.value.column.key == 'exemption'">{{
                  slotprops.value.record?
                    slotprops.value.record.exemption_value:
                    (Object.keys(slotprops.value.record.rule).length ? slotprops.value.record.rule.exemption_value : null)
                }}
                </p>
                <p v-if="slotprops.value.column.key == 'planned'" :disabled="(slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.abbreviation : slotprops.value.record.display_group) == '80TTA' || (slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.abbreviation : slotprops.value.record.display_group) == '80TTB'">
                   <txt type="number" :disable="['Additional NPS Employee Contribution', 'Provident Fund (PF)','Voluntary Provident Fund (VPF)','NPS Employer Contribution'].includes(slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.name : slotprops.value.record.name)" :name="'explannedvalue' + slotprops.value.index"
                    v-model="chapterData[slotprops.value.index].planned"
                    v-validate="{ required: true, regex: /^[1-9]{1}[0-9]{6}$/ }" />
                  <!-- <span v-else>-</span> -->
                </p>
              </div>
            </template>
          </data-table>
        </div>
      </div>
      <footer>
        <popup-bottom-container>
            <toast-message style="width:48rem;" :message="errmsg" type="error" :isToastEnable="toast" @close="(val) => toast = val" />
          <template slot="end">
            <btn-grp class="form-button">
              <btn text="Cancel" type="secondary" @click="goBack" />
              <btn :text="saveAsDraft ? 'Save as Draft' : 'Save'" type="primary" @click="validationForComponent"  v-if="itEnableValue"/>
            </btn-grp>
          </template>
        </popup-bottom-container>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "deductionsUnderCdeu",
  props: {
    regimeType:{
      type: String
    },
    itEnableValue:{
      type: String,
      required: true
    },
    ChapterVIA:{
      type: Array
    },
    saveAsDraft: {
      type: Boolean
    }
  },
  data() {
    return {
      errmsg: "",
      fetchLe_id: localStorage.getItem('le_id'),
      data1: [],
      toast: false,
      showSuccessMsg: false,
      chapterData: [],
      exemptTableColumns: [
        {
          label: "SL No.",
          key: "slno"
        },
        {
          label: "Particulars",
          key: "particulars"
        },
        {
          label: "Yearly limits",
          key: "limits"
        },
        {
          label : 'Salary Exemption',
          key: 'exemption'
        },
        {
          label: "Planned",
          key: "planned"
        }
      ],
    };
  },
  computed: {
    le_id() {
      return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
        this.$route.params.entity_index
      );
    },
  },

  mounted() {
    this.showSuccessMsg = false;
    this.load();
  },

  activated() {
    this.toast = false;
    this.errmsg = "";
    this.showSuccessMsg = false;
  },

  methods: {
    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),
    load(){
       let data2 = [];
       this.ChapterVIA.map(element => {
        let name = element.InvestmentComponentType ? element.InvestmentComponentType.name : element.name
        if(this.regimeType == "New Regime"){
          if(name == "NPS Employer Contribution"){
            element.InvestmentComponentType.maximumAmount = "14% of Basic + DA"
            data2.push(element);
          }
        }else{
          // Adding this if block specifically for "RELIGARE BROKING LIMITED" requested by "MariMuthu"
          if(this.fetchLe_id == "638e0ce2-bf4b-41e5-9b5f-b97aac6c2db2"){
            if(name !== "Provident Fund - Previous Employer"
            && name !== "Voluntary Provident Fund (VPF) - Previous Employer" && name !== "NPS Employer Contribution - Previous Employer"){
            data2.push(element);
          }
          if(name == "Provident Fund - Previous Employer"
            || name == "Voluntary Provident Fund (VPF) - Previous Employer" || name == "NPS Employer Contribution - Previous Employer"){
              element.planned = 0;
              this.data1.push(element);
          }
          }
          else{
          //PL-6918 -- Adding this if block specifically for "Detpack-DK4BG" requested by "Prakashan"
          if(this.fetchLe_id == 'e5d057f9-dac4-4fc3-9a31-cdf8d76fbc63'){
            if(name !== "Provident Fund - Previous Employer"
            && name !== "Voluntary Provident Fund (VPF) - Previous Employer" && name !== "NPS Employer Contribution - Previous Employer"){
            data2.push(element);            
          }
        }
          else if(name !== "Donation - Prime Minister Relief Fund" && name !== "Donation - Chief Minister Relief Fund" && name !== "Provident Fund - Previous Employer"
            && name !== "Voluntary Provident Fund (VPF) - Previous Employer" && name !== "NPS Employer Contribution - Previous Employer"){
            data2.push(element);            
          }
          else if(name == "Donation - Prime Minister Relief Fund" || name == "Donation - Chief Minister Relief Fund" || name == "Provident Fund - Previous Employer"
            || name == "Voluntary Provident Fund (VPF) - Previous Employer" || name == "NPS Employer Contribution - Previous Employer"){
              element.planned = 0;
              this.data1.push(element);
          }
        }
        }
       })
       //let data2 =this.ChapterVIA;
         this.chapterData = [];
          data2.forEach(element => {
            this.chapterData.push({
              planned: element.planned ? element.planned : 0,
              ...element
            });
          });
    },

    // Add here code for cancel button to hide popup By Bhushan 
    goBack() {
      this.$emit('back');
    },
    
    async validationForComponent(){
      this.toast = false
      this.errmsg = ""
      let res =this.chapterData.map((item)=>{
          if(item.InvestmentComponentType.name == 'Medical Treatment Expenses for Handicapped Dependent Sever Disability (> 80%)' && item.planned >0 ){
            this.chapterData.map((data)=>{
               if(data.InvestmentComponentType.name == 'Medical Treatment Expenses for Handicapped Dependent (Disabiity 40% - 80%)' && data.planned >0){
                  this.toast = true
                  this.errmsg = "You can't claim both disability levels under Medical Treatment Expenses for Handicapped Dependent"
               }
            })
          }else if( item.InvestmentComponentType.name == 'Medical Treatment Expenses for Handicapped Dependent (Disability 40% - 80%)'&& item.planned >0){
            this.chapterData.map((data)=>{
               if(data.InvestmentComponentType.name == 'Medical Treatment Expenses for Handicapped Dependent Sever Disability (> 80%)' && data.planned >0){
                  this.toast = true
                  this.errmsg = "You can't claim both disability levels under Medical Treatment Expenses for Handicapped Dependent"
               }
            })
          }else if(item.InvestmentComponentType.name == ' Medical Treatment Expenses - Specified Diseases Sr Citizen'&& item.planned >0){
            this.chapterData.map((data)=>{
               if(data.InvestmentComponentType.name == 'Medical Treatment Expenses - Specified Diseases' && data.planned >0){
                  this.toast = true
                  this.errmsg = "You can't claim both the levels under Medical Treatment Expenses - Specified Diseases"
               }
            })
          }
          else if(item.InvestmentComponentType.name == 'Medical Treatment Expenses - Specified Diseases'&& item.planned >0 ){
            this.chapterData.map((data)=>{
               if(data.InvestmentComponentType.name == 'Medical Treatment Expenses - Specified Diseases Sr Citizen' && data.planned >0){
                  this.toast = true
                  this.errmsg = "You can't claim both the levels under Medical Treatment Expenses - Specified Diseases"
               }
            })
          }
          else if(item.InvestmentComponentType.name == 'Medical Insurance Premium Self & Family Sr. Citizen'&& item.planned >0 ){
            this.chapterData.map((data)=>{
               if(data.InvestmentComponentType.name == 'Medical Insurance Premium Self & Family ' && data.planned >0){
                  this.toast = true
                  this.errmsg = "You can't claim both the levels of Medical Insurance Premium Self, Parents & Family Sr. Citizen"
               }
            })
          }
          else if(item.InvestmentComponentType.name == 'Medical Insurance Premium Self & Family'&& item.planned >0 ){
            this.chapterData.map((data)=>{
               if(data.InvestmentComponentType.name == 'Medical Insurance Premium Self & Family Sr. Citizen' && data.planned >0){
                  this.toast = true
                  this.errmsg = "You can't claim both the levels of Medical Insurance Premium Self, Parents & Family Sr. Citizen"
               }
            })
          }
          else if(item.InvestmentComponentType.name == 'Medical Insurance Premium Parents'&& item.planned >0 ){
            this.chapterData.map((data)=>{
               if(data.InvestmentComponentType.name == 'Medical Insurance Premium Parents Sr. Citizen' && data.planned >0){
                  this.toast = true
                  this.errmsg = "You can't claim both the levels under Medical Insurance Premium 80D"
               }
            })
          }
          else if(item.InvestmentComponentType.name == 'Medical Insurance Premium Parents Sr. Citizen'&& item.planned >0 ){
            this.chapterData.map((data)=>{
               if(data.InvestmentComponentType.name == 'Medical Insurance Premium Parents' && data.planned >0){
                  this.toast = true
                  this.errmsg = "You can't claim both the levels under Medical Insurance Premium 80D" 
               }
            })
          }
          else if(item.InvestmentComponentType.name == 'Person with Sever Disability (>80%)'&& item.planned >0 ){
            this.chapterData.map((data)=>{
               if(data.InvestmentComponentType.name == 'Person with Disability (40% - 80%)' && data.planned >0){
                  this.toast = true
                  this.errmsg = "You can't claim both disability levels under 80U"
               }
            })
          }
          else if(item.InvestmentComponentType.name == 'Person with Disability (40% - 80%)'&& item.planned >0 ){
            this.chapterData.map((data)=>{
               if(data.InvestmentComponentType.name == 'Person with Sever Disability (>80%)' && data.planned >0){
                  this.toast = true
                  this.errmsg = "You can't claim both disability levels under 80U"
               }
            })
          }
      })
      if(this.toast == false){
        this.submitData()
      }
     
    },
    async submitData() {
      let chapterData = [...this.chapterData, ...this.data1]
      this.$emit("chapterVIA", chapterData);
      //this.$emit("data1", this.data1);
    },
  },
};
</script>

<style lang="scss" scoped>

// .business {
//   width: 100%;
//   height: 100%;
// }

// .business .top-bar {
//   height: auto;
//   padding: 20px;
//   background-color: #34c0be;
//   display: flex;
// }

.search-container {
  width: auto;
}

.border-right-side {
  border-right: 2px solid #dddddd;
  padding-right: 0px;
}

.line-color {
  border-right: 2px solid #dddddd;
}

.img-float-right-side {
  float: right;
}

.tl-checkbox .container {
  font-size: 0.9rem;
}

.text-right-side {
  float: right;
}

.section-table {
  padding: 24px 0px;
}

.datatable-outer-container {
  width: 100%;
}
        
.datatable-outer-container table.datatable {
            width: 100%;
            border-collapse: collapse;
            margin: 0 auto;
            font-family: Montserrat;
            margin-bottom: 4px;
}
        
        .datatable-outer-container table.datatable .header-row {
            background-color: white;
            height: 54px;
        }
        
        .datatable-outer-container table.datatable .header-row th {
            background-color: #f0f1f5;
            border-bottom: 1px solid #34c0be;
            padding: 6px 20px;
        }
        
        .datatable-outer-container table.datatable .header-row th .tl-checkbox {
            text-align: center;
        }
        
        .datatable-outer-container table.datatable .inactiveCols {
            opacity: 0.03;
            background-color: #a2a1a1;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader {
            background-color: #ffffff;
            -webkit-box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
            box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th {
            padding: 0 8px;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th span {
            border-right: 1px solid #ececec;
            padding: 0px 18px 0px 15px;
            display: inline-block;
            vertical-align: middle;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th span:first-child {
            padding: 10px 10px 7px 10px;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type {
            text-align: right;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type span {
            border-right: none;
            font-weight: 400;
            font-style: italic;
            position: relative;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type span i {
            position: absolute;
            right: 10px;
            top: 2px;
        }
        
        .datatable-outer-container table.datatable .record-row {
            height: 60px;
            border-bottom: none;
        }
        
        .datatable-outer-container table.datatable .record-row:nth-child(odd) {
            background-color: #fff;
        }
        
        .datatable-outer-container table.datatable .record-row.selectedRecord {
            background-color: #E9F9F8;
            opacity: 0.9;
        }
        
        .datatable-outer-container table.datatable .record-row td {
            padding: 6px 8px;
            color: #646464;
            font-weight: 500;
        }
        
        .datatable-outer-container table.datatable .record-row td .tl-checkbox {
            text-align: center;
        }
        
        .datatable-outer-container table.datatable .record-row .actions {
            width: 10%;
            padding: 10px;
        }
        
        .datatable-outer-container table.datatable .record-row .row-item {
            padding: 6px 20px;
        }
        
        .datatable-outer-container table.datatable .record-row .row-item p {
            width: 100%;
            margin-bottom: 0px;
        }
        
        .datatable-outer-container table.datatable .record-row .action-img {
            display: inline-block;
            cursor: pointer;
            opacity: 0;
        }
        
        .datatable-outer-container table.datatable .record-row:hover .action-img {
            opacity: 1;
        }

.inputbox{
   width: 149px;
  height: 35px;
  // width: 30%;
  padding: 4px;
  border: 1px solid #c6c9c8;
  border-radius: 4px;
  &:focus {
        outline: none;
        border: 2px solid #37c6c0;
    }
}

.inputbox-large{
  height: 35px;
  width: 30%;
  padding: 4px;
  border: 1px solid #c6c9c8;
  border-radius: 4px;
  &:focus {
        outline: none;
        border: 2px solid #37c6c0;
    }
}


</style>
